import React$1, { useState, useEffect } from 'react';
import PropTypes$1 from 'prop-types';
import StyledIcon from './Icon.style.js';

const Icon = ({
  icon,
  alignment
}) => {
  const [importedIcon, setImportedIcon] = useState(null);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(true);

    const importIcon = async () => {
      try {
        const {
          default: DynamicIcon
        } = await import(`./svgs/${icon}`);
        setImportedIcon( /*#__PURE__*/React$1.createElement(DynamicIcon, null));
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    importIcon();
  }, [icon]);

  if (!loading && importedIcon) {
    return /*#__PURE__*/React$1.createElement(StyledIcon, {
      icon: icon,
      alignment: alignment
    }, alignment === 'right' && /*#__PURE__*/React$1.createElement(React$1.Fragment, null, "\xA0"), importedIcon, alignment === 'left' && /*#__PURE__*/React$1.createElement(React$1.Fragment, null, "\xA0"));
  }

  return null;
};

Icon.propTypes = {
  icon: PropTypes$1.string.isRequired,
  alignment: PropTypes$1.oneOf(['right', 'left', 'none'])
};
Icon.defaultProps = {
  alignment: 'right'
};

export default Icon;
